import { useEffect } from 'react';
import { gtmService } from '../../../services/gtm';

export const GTMInitializer = () => {
  useEffect(() => {
    const gtmId = import.meta.env.VITE_GTM_ID;
    const isProduction = import.meta.env.MODE === 'production';

    if (isProduction && gtmId) {
      gtmService.initialize(gtmId);
    } else if (import.meta.env.DEV) {
      if (!isProduction) {
        console.log('[GTM] Skipped: Not in production mode');
      }
      if (!gtmId) {
        console.warn('[GTM] Skipped: VITE_GTM_ID not configured');
      }
    }
  }, []);

  return null;
};
